// extracted by mini-css-extract-plugin
module.exports = {"accordion":"location_filter-module_accordion_12f02"};